/**
 * Alturas de texto, em milímetros.
 *
 * O motor não mede nada em tempo de execução — mas precisa saber **quanto um
 * texto ocupa** para dimensionar uma caixa pelo conteúdo, em vez de por uma
 * fração da folha.
 *
 * A diferença importa porque as duas contas olham para lados diferentes do
 * papel: o tamanho da letra acompanha a **largura** (é ela que decide o
 * comprimento da linha), e a fração acompanha a **altura**. Num papel baixo e
 * largo — o quadrado — ou no A6 com dois dias por página, a fração fica menor
 * que o texto e o `overflow: hidden` corta em silêncio.
 */
import { ENTRELINHA_PADRAO, tamanhoFontePt } from './papel.js';
/**
 * Linhas que um texto ocupa na largura disponível.
 *
 * A largura média de um caractere é metade da altura da fonte: erra para menos
 * em textos longos, e por isso quem usa esta conta para dimensionar caixa deve
 * deixar uma folga. `larguraRelativa` é a correção de quem escolheu uma fonte
 * pelo nome (`FATOR_LARGURA_FONTE`): a conta nasceu para a fonte do sistema, e
 * trocar por uma geométrica larga sem corrigir aqui cortaria a última linha em
 * silêncio.
 */
export function linhasDoTexto(texto, pt, larguraMm, larguraRelativa = 1) {
    const larguraCaractereMm = pt * 0.3528 * 0.5 * larguraRelativa;
    const porLinha = Math.max(8, Math.floor(larguraMm / larguraCaractereMm));
    return texto
        .split('\n')
        .reduce((total, parte) => total + Math.max(1, Math.ceil(parte.length / porLinha)), 0);
}
/** Altura de um texto, em milímetros — a mesma conta que o desenho usa. */
export function alturaDoTextoMm(texto, formato, tamanho, larguraMm, escala = 1, tracking = 0, larguraRelativa = 1) {
    const pt = tamanhoFontePt(formato, tamanho, escala, tracking);
    const entrelinha = ENTRELINHA_PADRAO[tamanho];
    return Number((linhasDoTexto(texto, pt, larguraMm, larguraRelativa) * pt * 0.3528 * entrelinha).toFixed(2));
}
//# sourceMappingURL=medidas.js.map